import { Text, VStack } from '@chakra-ui/react';
import _, { truncate } from 'lodash';
import * as React from 'react';

type ITruncatedItemNameProps = {
  name: string;
  minEndChars: number;
  numOfLines?: number;
  maxLineLength?: number;
  textStyle?: string;
};

export const TruncatedItemName: React.FC<ITruncatedItemNameProps> = ({
  name,
  minEndChars,
  numOfLines,
  maxLineLength,
  textStyle = 'body',
}) => {
  // This produces invalid behavior, but it wouldn't make sense to use this component with numbers outside
  // this range, so it would be a developer error
  if (!numOfLines || !maxLineLength) return null;
  if (numOfLines < 1 || maxLineLength < 1 || minEndChars < 0) return null;

  const substrs = _.chunk(name.split(''), maxLineLength).map((chunk) =>
    chunk.join('')
  );
  if (substrs.length < 1) return null;
  if (substrs.length <= numOfLines) {
    return (
      <VStack align="left">
        {substrs.map((str) => (
          <Text
            key={str}
            textStyle={textStyle}
            lineHeight={substrs.length > 1 ? '3' : ''}
          >
            {str}
          </Text>
        ))}
      </VStack>
    );
  }

  const lastLine = substrs[substrs.length - 1];
  const secondLastLine = substrs[substrs.length - 2];

  const end =
    lastLine && lastLine.length >= minEndChars
      ? lastLine.slice(-minEndChars)
      : lastLine && secondLastLine
      ? secondLastLine.slice(-(minEndChars - lastLine.length)) + lastLine
      : '';

  const truncatedLastLine =
    truncate(substrs[numOfLines - 1], {
      length: maxLineLength - 3,
    }) + end;
  return (
    <VStack align="left">
      {substrs.slice(0, numOfLines - 1).map((str) => (
        <Text key={str} textStyle={textStyle} lineHeight="3">
          {str}
        </Text>
      ))}
      <Text textStyle={textStyle} lineHeight="3">
        {truncatedLastLine}
      </Text>
    </VStack>
  );
};
